import { Routes } from '@angular/router';
import { authGuard } from './auth/guards/auth.guard';
import { superAdminGuard } from './auth/guards/super-admin.guard';

export const routes: Routes = [
  {
    path: 'auth/login',
    loadComponent: () => import('./auth/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'auth/callback',
    loadComponent: () => import('./auth/callback/callback.component').then(m => m.CallbackComponent),
  },
  {
    path: 'auth/ephemeral-login',
    loadComponent: () => import('./auth/ephemeral-login/ephemeral-login.component').then(m => m.EphemeralLoginComponent),
  },
  {
    path: 'auth/logout',
    loadComponent: () => import('./auth/logout/logout.component').then(m => m.LogoutComponent),
  },
  {
    path: 'auth/unauthorized',
    loadComponent: () => import('./auth/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent),
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [superAdminGuard],
  },
  {
    path: 'design2',
    loadComponent: () => import('./design2/design2.component').then(m => m.Design2Component),
    canActivate: [superAdminGuard],
  },
  {
    path: 'reports/per-day-summary/:account/:date',
    loadComponent: () =>
      import('./reports/account-daily-trades/account-daily-trades.component').then(
        (m) => m.AccountDailyTradesComponent,
      ),
    canActivate: [superAdminGuard],
  },
  {
    path: 'reports/per-day-summary',
    loadComponent: () => import('./reports/per-day-summary/per-day-summary.component').then(m => m.PerDaySummaryComponent),
    canActivate: [superAdminGuard],
  },
  {
    path: 'reports/gemini-cost',
    loadComponent: () => import('./reports/gemini-cost/gemini-cost.component').then(m => m.GeminiCostComponent),
    canActivate: [superAdminGuard],
  },
  {
    path: 'reports/per-symbol-day-trades',
    loadComponent: () => import('./reports/per-symbol-day-trades/per-symbol-day-trades.component').then(m => m.PerSymbolDayTradesComponent),
    canActivate: [superAdminGuard],
  },
  {
    path: 'reports/per-setup-report',
    loadComponent: () => import('./reports/per-setup-report/per-setup-report.component').then(m => m.PerSetupReportComponent),
    canActivate: [authGuard],
  },
  {
    path: 'reports/symbol-trade-setup-detail',
    loadComponent: () =>
      import('./reports/symbol-trade-setup-detail/symbol-trade-setup-detail.component').then(
        (m) => m.SymbolTradeSetupDetailComponent,
      ),
    canActivate: [superAdminGuard],
  },
  {
    path: 'admin/data-explorer',
    loadComponent: () => import('./admin/data-explorer/data-explorer.component').then(m => m.DataExplorerComponent),
    canActivate: [superAdminGuard],
  },
  {
    path: 'admin/worker-logs',
    loadComponent: () => import('./admin/worker-logs/worker-logs.component').then(m => m.WorkerLogsComponent),
    canActivate: [superAdminGuard],
  },
  {
    path: 'admin/refinement-pipeline',
    loadComponent: () => import('./admin/refinement-pipeline/refinement-pipeline.component').then(m => m.RefinementPipelineComponent),
    canActivate: [superAdminGuard],
  },
  {
    path: 'admin/super-admins',
    loadComponent: () => import('./admin/super-admins/super-admins.component').then(m => m.SuperAdminsComponent),
    canActivate: [superAdminGuard],
  },
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  { path: '**', redirectTo: 'dashboard' },
];
